module.exports = "<div class=\"admission-group-not-visible-modal\">\n  <div class=\"modal-header capitalize\">\n    <button type=\"button\" class=\"close\" ng-click=\"close()\">×</button>\n    <h4 class=\"modal-title\">\n      {{ modalHeader }}\n    </h4>\n  </div>\n  <div class=\"modal-body clearfix\">\n    <button class=\"btn btn-primary pull-left\" ng-click=\"onClick($event)\">\n      View Reservation\n    </button>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/modals/admissionGroupNotVisible/template.html
// module id = 1247
// module chunks = 0